import APP from "./app/appObj";
import { respectReducedMotion } from "./utils/reducedMotion";

/**
 * Get Document Ready
 */
document.addEventListener("DOMContentLoaded", () => {
  APP.helpers.initComponents(document.body, APP);
  respectReducedMotion();
});
